import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import LeaderboardScore from "../../../components/LeaderboardScore/LeaderboardScore";
import ProfileCard from "../../../components/ProfileCard/ProfileCard";
import Notification from "../../../components/Notification/Notification";
import "../../Dashboard/Dashboard.css";
import {
  getCollectorDocument,
  getDashboardDataColl,
  getUserInfo,
} from "../../../api/collectorApi/sfdx_collector_apis";
import { connect } from "react-redux";
import { firebase } from "../../../config/fb_config";
import DownloadOurApp from "../../../components/ui_utilities/DownloadOurApp";
import FAVICON from "../../../asset/images/app_icon.png";
import Sidebar from "../../../components/Sidebar/Sidebar";
import { CircularProgressbar } from "react-circular-progressbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";
import swal from "sweetalert2";
import Swal from "sweetalert2";

const CollectorDashboard = ({ auth, history }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState("daily");
  const [dailyData, setDailyData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [yearlyData, setYearlyData] = useState([]);
  const [sfId, setSfId] = useState("");
  const [fbUser, setFbUser] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [duration, setDuration] = useState("daily");
  const [customShowResult, setCustomShowResult] = useState(false);
  const navigate = useNavigate();
  const [popUp, setPopUp] = useState(true);

  useEffect(() => {
    firebase
      .firestore()
      .collection("user")
      .doc(auth.uid)
      .get()
      .then((doc) => {
        console.log("FB Data ", doc.data());
        const data = doc.data();

        // Agar documents submit hue hain but approve nahi hue → underApproval
        if (data?.status === "document_submitted") {
          navigate("/underApproval");
          return;
        }

        setFbUser(data);
        setSfId(data.sf_id);
      })
      .catch((err) => {
        console.log("Error to fetch mentor profile ", err);
      });
  }, [auth.uid]);

  const today = new Date();

  const currentDate = today.toISOString().split("T")[0];

  console.log(currentDate);

  useEffect(() => {
    debugger;
    try {
      if (sfId) {
        const fetchData = async () => {
          console.log("sfid----->", sfId);
          let data = null;
          if (!startDate || !endDate) {
            data = await getDashboardDataColl(
              sfId,
              duration,
              null,
              currentDate,
            );
          } else {
            const start_date = startDate.toLocaleDateString("en-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
            const end_date = endDate.toLocaleDateString("en-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
            console.log("startdate -  ", start_date);
            console.log("endadate---", end_date);
            data = await getDashboardDataColl(
              sfId,
              duration,
              start_date,
              end_date,
            );
          }
          console.log("API data-->", data);
          // if (isCustom) setDashboardData(data.AllReports.customDate_reports);
          setDashboardData(data);
          //setDailyData(data.AllReports.daily_reports);
          // setMonthlyData(data);
          // setYearlyData(data);
        };

        fetchData();
      }
    } catch (error) {
      console.log("Exceprion in API Collector Dashboard Calling - ", error);
      // swal({
      //   title:'Exception',
      //   text:'Something went wrong, please try agian',
      //   icon:'error'
      // });
    }
  }, [sfId, isCustom, duration]);

  console.log("dashboardData---------------->", dashboardData);

  const handleReportTypeChange = (event) => {
    debugger;

    const type = event.target.value.toLowerCase();
    setIsCustom(false);
    setSelectedReportType(type);
    debugger;
    switch (type) {
      case "daily":
        //setDashboardData(dailyData);
        setDuration("daily");
        break;
      case "monthly":
        //setDashboardData(monthlyData);
        setDuration("monthly");
        break;
      case "yearly":
        //setDashboardData(yearlyData);
        setDuration("yearly");
        break;
      default:
        setModalOpen(true);
        break;
    }
  };

  console.log("dashboardData---------------->", dashboardData);
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleDateChange = (date, field) => {
    if (field === "start") {
      setStartDate(date);
    } else if (field === "end") {
      setEndDate(date);
    }
  };
  const handleShowResult = () => {
    setDuration("custom");
    //setIsCustom(true);
    setModalOpen(false);
  };
  const usernameBlock = () => {
    if (fbUser)
      return (
        <>
          <h1
            style={{ display: "inline" }}
          >{`${fbUser.first_name}${" "}${fbUser.last_name}`}</h1>
        </>
      );
  };

  // REMOVE the entire second useEffect block and REPLACE WITH:
  // useEffect(() => {
  //   if (!sfId) return; // wait until first useEffect has set sfId

  //   const checkDocuments = async () => {
  //     try {
  //       const data = await getCollectorDocument(sfId);
  //       if (data && data.documents && Array.isArray(data.documents)) {
  //         const requiredDocs = data.documents.filter((doc) => doc.is_required);

  //         const anyRequiredNeedsAction = requiredDocs.some(
  //           (doc) => doc.status === "Pending" || doc.status === "Rejected",
  //         );

  //         if (anyRequiredNeedsAction) {
  //           // Required doc is pending upload or was rejected → send back to upload page
  //           navigate("/documents");
  //         }
  //         // All required docs are Uploaded/Approved → stay on dashboard (no navigation needed)
  //       }
  //     } catch (error) {
  //       console.error("Error fetching documents:", error);
  //     }
  //   };

  //   checkDocuments();
  // }, [sfId]); // runs whenever sfId becomes available

  // useEffect(() => {
  //   if (!sfId) return;

  //   const checkDocuments = async () => {
  //     try {
  //       const data = await getCollectorDocument(sfId);
  //       if (data && data.documents && Array.isArray(data.documents)) {
  //         const requiredDocs = data.documents.filter((doc) => doc.is_required);

  //         if (requiredDocs.length === 0) {
  //           // Scenario 2: all optional → user belongs on dashboard, stay
  //         } else {
  //           // Scenario 1: required docs exist → kick out if any need action
  //           const anyRejected = requiredDocs.some(
  //             (doc) => doc.status === "Rejected",
  //           );
  //           const anyPending = requiredDocs.some(
  //             (doc) => doc.status === "Pending",
  //           );

  //           if (anyRejected || anyPending) {
  //             navigate("/documents");
  //           }
  //           // all required Uploaded/Approved → stay on dashboard
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching documents:", error);
  //     }
  //   };

  //   checkDocuments();
  // }, [sfId]);

  useEffect(() => {
    if (!sfId) return;

    const checkDocuments = async () => {
      try {
        const data = await getCollectorDocument(sfId);
        if (data && data.documents && Array.isArray(data.documents)) {
          const requiredDocs = data.documents.filter((doc) => doc.is_required);

          const userDoc = await firebase
            .firestore()
            .collection("user")
            .doc(auth.uid)
            .get();

          const userData = await getUserInfo(sfId);
          const stage = userData.profile.stage;

          if (requiredDocs.length === 0) {
            const anyRejected = data.documents.some(
              (doc) => doc.status === "Rejected",
            );

            const userDoc = await firebase
              .firestore()
              .collection("user")
              .doc(auth.uid)
              .get();

            const firestoreStatus = userDoc.data()?.status;

            // ✅ rejection
            if (anyRejected) {
              await firebase
                .firestore()
                .collection("user")
                .doc(auth.uid)
                .update({
                  status: "new",
                });

              navigate("/documents");
              return;
            }

            // ✅ not active → go back
            if (stage === "Active") {
              await firebase
                .firestore()
                .collection("user")
                .doc(auth.uid)
                .update({
                  status: "new",
                });
              return;
            }

            navigate("/documents");

            // at least one Uploaded/Approved → stay on dashboard
          } else {
            // Scenario 1: required docs exist
            const anyRejected = requiredDocs.some(
              (doc) => doc.status === "Rejected",
            );
            const anyPending = requiredDocs.some(
              (doc) => doc.status === "Pending",
            );

            if (anyRejected || anyPending) {
              navigate("/documents");
            }
            // all required Uploaded/Approved → stay on dashboard
          }
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    checkDocuments();
  }, [sfId]);

  const last_date = "2026-06-10"; // from backend

  const getRemainingDays = (lastDate) => {
    const today = new Date();
    const expiryDate = new Date(lastDate);

    // remove time part
    today.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);

    const diffTime = expiryDate - today;

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  //! alert for re-upload of document
  // useEffect(() => {
  //   if (!last_date) return;

  //   const daysRemaining = getRemainingDays(last_date);

  //   console.log("Remaining Days:", daysRemaining);

  //   // expired
  //   if (daysRemaining < 0) {
  //     Swal.fire({
  //       title: "Account Blocked",
  //       text: "Please upload new documents to unblock your account!",
  //       icon: "error",
  //       showCancelButton: true,
  //       confirmButtonText: "Upload Documents",
  //       cancelButtonText: "Remind me later",
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       allowOutsideClick: false,
  //       allowEscapeKey: false,
  //       backdrop: `rgba(0,0,0,0.5)`,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         navigate("/new_document");
  //       }
  //     });
  //   }

  //   // exact expiry date
  //   else if (daysRemaining === 0) {
  //     Swal.fire({
  //       title: "Document Expiring Today",
  //       text: "Please upload new documents today.",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Upload Documents",
  //       cancelButtonText: "Later",
  //       allowOutsideClick: false,
  //       allowEscapeKey: false,
  //       backdrop: `rgba(0,0,0,0.5)`,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         navigate("/new_document");
  //       }
  //     });
  //   }

  //   // within 15 days
  //   else if (daysRemaining <= 15) {
  //     Swal.fire({
  //       title: "Upload Documents",
  //       text: `${daysRemaining} day(s) remaining before expiry.`,
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Upload Documents",
  //       cancelButtonText: "Remind me later",
  //       allowOutsideClick: false,
  //       allowEscapeKey: false,
  //       backdrop: `rgba(0,0,0,0.5)`,
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         navigate("/new_document");
  //       }
  //     });
  //   }
  // }, [last_date, navigate]);

  return (
    <div className="flex flex-row">
      <div className="flex-2">
        <Sidebar />
      </div>
      <div className="flex-1">
        <div className="mid-section">
          {isModalOpen && (
            <div className="modal">
              <div className="modal-content custom-date">
                <span className="close" onClick={handleCloseModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4.39705 4.55379L4.46967 4.46967C4.73594 4.2034 5.1526 4.1792 5.44621 4.39705L5.53033 4.46967L12 10.939L18.4697 4.46967C18.7626 4.17678 19.2374 4.17678 19.5303 4.46967C19.8232 4.76256 19.8232 5.23744 19.5303 5.53033L13.061 12L19.5303 18.4697C19.7966 18.7359 19.8208 19.1526 19.6029 19.4462L19.5303 19.5303C19.2641 19.7966 18.8474 19.8208 18.5538 19.6029L18.4697 19.5303L12 13.061L5.53033 19.5303C5.23744 19.8232 4.76256 19.8232 4.46967 19.5303C4.17678 19.2374 4.17678 18.7626 4.46967 18.4697L10.939 12L4.46967 5.53033C4.2034 5.26406 4.1792 4.8474 4.39705 4.55379L4.46967 4.46967L4.39705 4.55379Z"
                      fill="#242424"
                    />
                  </svg>
                </span>
                <h2>Custom Date</h2>
                <div style={{ gap: "1.5rem", display: "flex" }}>
                  <div>
                    <label>Start Date:</label>
                    <DatePicker
                      selected={startDate}
                      dateFormat="yyyy-MM-dd"
                      onChange={(date) => handleDateChange(date, "start")}
                      className="date-picker"
                    />
                  </div>
                  <div>
                    <label>End Date:</label>
                    <DatePicker
                      selected={endDate}
                      dateFormat="yyyy-MM-dd"
                      onChange={(date) => handleDateChange(date, "end")}
                      className="date-picker"
                    />
                  </div>
                </div>
                <div style={{ marginTop: "3rem", textAlign: "center" }}>
                  <button
                    disabled={customShowResult}
                    onClick={() => {
                      handleShowResult();
                    }}
                    className="green-btn"
                  >
                    Show Results
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* <h2 style={{ marginBottom: "2rem", display: "inline", border: "1px solid" }}>
            Welcome Back, {usernameBlock()}
          </h2> */}
          {/* {usernameBlock()} */}

          <div
            style={{
              marginBottom: "2rem",
              marginTop: "1.5rem",
              color: "#484848",
              fontSize: "1.2rem",
            }}
          >
            Welcome Back,{" "}
            {fbUser && (
              <span
                style={{
                  color: "black",
                  fontSize: "2rem",
                  fontWeight: "600",
                }}
              >
                {fbUser.first_name} {fbUser.last_name}
              </span>
            )}
          </div>

          <div className="columns-3">
            <select
              className="form-control1"
              onChange={handleReportTypeChange}
              value={selectedReportType}
            >
              <option value="daily">Daily Report</option>
              <option value="monthly">Monthly</option>

              <option value="yearly">Yearly</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <div className="dashboard_box">
            <div className="grey-card">
              <h3>Total Plastic (Kg)</h3>
              <h4 className="text-blue">
                {dashboardData
                  ? dashboardData.totalPlastic
                    ? dashboardData.totalPlastic
                    : 0
                  : 0}
              </h4>
              {/* <Link
                to={"/HardPlasticCollected"}
                className="details-btn"
                state={{
                  caseList: "",
                  plastic_type: "",
                  total: dashboardData
                    ? dashboardData.totalPlastic
                      ? dashboardData.totalPlastic
                      : 0
                    : 0,
                  filter: "total",
                  duration: duration,
                  user_id: sfId,
                  startDate: startDate,
                  endDate: endDate,
                  user_id: sfId,
                }}
              >
                View Details
              </Link> */}
            </div>

            {/* <div className='grey-card'>
                            <h3>Tickets In Progress</h3>
                            <h4 className='text-orange'>{dashboardData?.tickets_in_progress || '0'}</h4>
                            <Link
                                to={ '/TicketRaised'}
                                className="details-btn"
                                state={{ caseList: dashboardData?dashboardData.caseList?dashboardData.caseList:null:null,ticketType:'progress',title:'Tickets In Progress' }}
                                >
                                View Details
                            </Link>
                        </div> */}
            {/* <div className="grey-card">
              <h3>New Requests</h3>
              <h4 className="text-orange">
                {dashboardData?.ticket_raised || "0"}
              </h4>
              <Link
                to={"/TicketRaised"}
                className="details-btn"
                state={{
                  caseList: dashboardData
                    ? dashboardData.caseList
                      ? dashboardData.caseList
                      : null
                    : null,
                  ticketType: "New",
                  title: "New Requests",
                }}
              >
                View Details
              </Link>
            </div> */}
            <div className="grey-card">
              <h3>Hard Plastic Collected (Kg)</h3>
              <h4 className="text-purple">
                {dashboardData
                  ? dashboardData.hardPlasticData
                    ? dashboardData.hardPlasticData
                    : 0
                  : 0}
              </h4>
              <Link
                to={"/HardPlasticCollected"}
                state={{
                  caseList: "",
                  plastic_type: "Hard",
                  total: dashboardData
                    ? dashboardData.hardPlasticData
                      ? dashboardData.hardPlasticData
                      : 0
                    : 0,
                  filter: "hardplastic",
                  duration: duration,
                  user_id: sfId,
                  startDate: startDate,
                  endDate: endDate,
                  user_id: sfId,
                }}
                className="details-btn"
              >
                View Details
              </Link>
            </div>
            <div className="grey-card">
              <h3>Soft Plastic Collected (Kg)</h3>
              <h4 className="text-pink">
                {dashboardData
                  ? dashboardData.softPlasticData
                    ? dashboardData.softPlasticData
                    : 0
                  : 0}
              </h4>
              <Link
                to={"/HardPlasticCollected"}
                state={{
                  caseList: "",
                  plastic_type: "Soft",
                  total: dashboardData
                    ? dashboardData.softPlasticData
                      ? dashboardData.softPlasticData
                      : 0
                    : 0,
                  filter: "softplastic",
                  duration: duration,
                  user_id: sfId,
                  startDate: startDate,
                  endDate: endDate,
                  user_id: sfId,
                }}
                className="details-btn"
              >
                View Details
              </Link>
            </div>
            <div className="lg-grey-card" style={{ gridColumn: "span 2" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h4>Collections Completed</h4>
                  <Link
                    to={"/TicketRaised"}
                    className="details-btn"
                    state={{
                      caseList: "",
                      ticketType: "closed",
                      title: "Collection Request",
                      filter: "completedcollection",
                      startDate: startDate,
                      endDate: endDate,
                      duration: duration,
                      user_id: sfId,
                    }}
                  >
                    View Details
                  </Link>
                </div>
                <div style={{ paddingTop: "0.5rem" }}>
                  <div style={{ width: 160, height: 160 }}>
                    {/* https://codesandbox.io/p/sandbox/progressbar-fontweight-forked-7t7qdp?file=%2Fsrc%2FApp.js%3A28%2C11-35%2C12 */}
                    <CircularProgressbar
                      // value={
                      //   dashboardData
                      //     ? dashboardData.solved_percentage
                      //       ? dashboardData.solved_percentage
                      //       : 0
                      //     : 0
                      // }
                      styles={{
                        text: {
                          fontSize: "1rem",
                          fontWeight: 500,
                        },
                        path: {
                          stroke: "#009E8C",
                        },
                      }}
                      value={
                        dashboardData
                          ? dashboardData.solved_percentage
                            ? dashboardData.solved_percentage
                            : 0
                          : 0
                      }
                      text={`${
                        dashboardData
                          ? dashboardData.completedCollections
                            ? dashboardData.completedCollections
                            : 0
                          : 0
                      }`}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grey-card">
              <h3>Overdue Collections</h3>
              <h4 className="text-blue">
                {dashboardData
                  ? dashboardData.overdueData
                    ? dashboardData.overdueData
                    : 0
                  : 0}
              </h4>
              <Link
                to={"/TicketRaised"}
                className="details-btn"
                state={{
                  caseList: "",
                  ticketType: "overdue",
                  title: "Overdue Tickets",
                  filter: "overdue",
                  startDate: startDate,
                  endDate: endDate,
                  duration: duration,
                  user_id: sfId,
                }}
              >
                View Details
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-2">
        <div className="right-section">
          <LeaderboardScore />
          <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
            <ProfileCard profile={fbUser} />
          </div>
          {/* <Notification /> */}
          {
            <DownloadOurApp
              downloadUrl={process.env.REACT_APP_DOWNLOAD_URL}
              appTitle={"BFC"}
              appDescription={"Android Application"}
              // imageUrl={FAVICON}
              imageUrl={"../../../asset/images/new_BFC_logo_white.png"}
            />
          }
        </div>
      </div>
      {/* {popUp && (
        <div className="popup_reupload">
          
        </div>
      )} */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
  };
};

export default connect(mapStateToProps, null)(CollectorDashboard);
